// WHAT ACTUALLY HAPPENED: how long the meeting really ran, and what was said.
//
// THE ACTUAL DURATION IS NOT THE BOOKED ONE, and the form keeps them apart on purpose.
// The hour that was booked stays on the meeting untouched; this records the hour it took.
// A meeting scheduled for 60 minutes that ran 20 is a fact worth having, and overwriting
// the schedule with it would destroy what was agreed.
//
// IT IS OPTIONAL, and the hint says so. "It ran about as planned" is a real answer, and a
// required field would be answered with an invented number — which is worse than none,
// because an invented number looks like a measurement. The TEXT is what is required: a
// summary with no words records nothing (the server refuses it, and so does the schema).
//
// Off the half-hour grid on purpose. The grid is a BOOKING convention — meetings start on
// the half hour so a day can be read — and has nothing to say about how long a
// conversation lasted. 45 minutes is a perfectly ordinary answer here and an illegal
// booking length.
import { useState } from 'react';
import he from '../../i18n/he';
import Button from '../../components/Button';
import { Field, Textarea } from '../../components/Form';
import { ErrorText } from '../../components/Loader';

export default function SummaryForm({ meeting, onSave }) {
  const [minutes, setMinutes] = useState(meeting.actual_minutes ?? '');
  const [text, setText] = useState(meeting.summary || '');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const submit = async () => {
    setBusy(true);
    setError(null);
    try {
      await onSave({ actual_minutes: minutes === '' ? null : Number(minutes), summary: text });
    } catch (e) {
      setError(e);
      setBusy(false);
    }
  };

  return (
    <div className="summary-form">
      <Field label={he.calendar.actualDuration}>
        <input
          type="number"
          min="1"
          step="5"
          value={minutes}
          onChange={(e) => setMinutes(e.target.value)}
        />
      </Field>

      <Textarea
        label={he.calendar.summaryText}
        value={text}
        onChange={(e) => setText(e.target.value)}
        placeholder={he.calendar.summaryPlaceholder}
        rows={5}
      />

      <div className="actions">
        <Button onClick={submit} disabled={busy || !text.trim()}>
          {busy ? he.common.loading : he.common.save}
        </Button>
      </div>

      {error && <ErrorText error={error} />}
    </div>
  );
}
